import { Observable } from 'rxjs'

import store from '@/store'

import { ChannelAPIConstant } from '../constant/channel'
import { PmcPage } from '../model/base'
import { Bank, BankDetail, Channel, PaymentType, PayType } from '../model/channel'
import { BaseService } from './base-service'

export class ChannelService extends BaseService {
    protected channelConstant: ChannelAPIConstant
    constructor() {
        super()
        this.channelConstant = new ChannelAPIConstant()
    }

    queryAbroadBankDropdown(data = {}): Observable<Bank[]> {
        return this.requestPmc(this.channelConstant.QueryAbroadBankDropdown(data))
    }

    queryPayTypeList(data = {}): Observable<PayType[]> {
        return this.requestPmc(this.channelConstant.QueryPayTypeList(data))
    }

    queryPaymentTypeList(data = {}): Observable<PaymentType[]> {
        return this.requestPmc(this.channelConstant.QueryPaymentTypeList(data))
    }

    queryPaymentTypeListByScene(data = ''): Observable<PaymentType[]> {
        return this.requestPmc(this.channelConstant.QueryPaymentTypeListByScene(data))
    }

    bankMerchantList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.channelConstant.BankMerchantList(data))
    }

    batchEnable(data = {}): Observable<boolean> {
        return this.requestPmc(this.channelConstant.BatchEnable(data))
    }

    batchDisable(data = {}): Observable<boolean> {
        return this.requestPmc(this.channelConstant.BatchDisEnable(data))
    }

    queryAbroadBankById(data = ''): Observable<BankDetail> {
        return this.requestPmc(this.channelConstant.QueryAbroadBankById(data))
    }

    bankMerchantUpdate(data = {}): Observable<any> {
        return this.requestPmc(this.channelConstant.BankMerchantUpdate(data))
    }

    bankMerchantAdd(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.BankMerchantAdd(data))
    }

    queryMerchantDropdownByUser(data = {}): Observable<any> {
        return this.requestPmc(this.channelConstant.QueryMerchantDropdownByUser(data))
    }

    queryMerchantDropdown(data = {}): Observable<any> {
        return this.requestPmc(this.channelConstant.QueryMerchantDropdown(data))
    }

    copy(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.Copy(data))
    }

    merchantManageList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.channelConstant.MerchantManageList(data))
    }

    merchantManageAdd(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.MerchantManageAdd(data))
    }

    merchantManageUpdate(data = {}): Observable<any> {
        return this.requestPmc(this.channelConstant.MerchantManageUpdate(data))
    }

    queryChannelDropdown(data = {}): Observable<Channel[]> {
        return this.requestPmc(this.channelConstant.QueryChannelDropdown(data))
    }

    channelList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.channelConstant.ChannelList(data))
    }

    addChannel(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.AddChannel(data))
    }

    editChannel(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.EditChannel(data))
    }

    abroadThirdParameterList(data = {}): Observable<PmcPage<any>> {
        Object.assign(data, { merchantId: store.getters.tenantId })
        return this.requestPmc(this.channelConstant.AbroadThirdParameterList(data))
    }

    addAbroadThirdParameterBatch(data = []): Observable<boolean> {
        data.map((item: any) => {
            item.merchantId = store.getters.tenantId
            return null
        })
        return this.requestPmc(this.channelConstant.AddAbroadThirdParameterBatch(data))
    }

    updateAbroadThirdParameter(data = {}): Observable<boolean> {
        return this.requestPmc(this.channelConstant.UpdateAbroadThirdParameter(data))
    }

    deleteAbroadThirdParameter(data = {}): Observable<boolean> {
        return this.requestPmc(this.channelConstant.DeleteAbroadThirdParameter(data))
    }

    routeControlList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.channelConstant.RouteControlList(data))
    }

    addRouteControl(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.AddRouteControl(data))
    }

    updateRouteControl(data = {}): Observable<number> {
        return this.requestPmc(this.channelConstant.UpdateRouteControl(data))
    }
}
